import React, {useState} from "react";
import {T, useTranslate} from "@tolgee/react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import {useTwoFactorSettings} from "store/two-factor/two-factor-settings.store";
import FfairModal from "view/components/modal/FfairModal";
import FfairPaper from "view/components/FfairPaper";
import Alert from "view/components/Alert";
import useStyles from "./styles";

type Props = {
  onClose: () => void;
  onEnable?: () => void;
};

const ActivationPromptModal: React.FC<Props> = ({onClose, onEnable}) => {
  const classes = useStyles();
  const {t} = useTranslate();
  const dismissActivationPrompt = useTwoFactorSettings(
    (state) => state.dismissActivationPrompt
  );
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleMaybeLater = async () => {
    if (dontShowAgain) {
      await dismissActivationPrompt();
    }
    onClose();
  };

  const handleEnable = async () => {
    if (dontShowAgain) {
      await dismissActivationPrompt();
    }
    onClose();
    onEnable?.();
  };

  return (
    <FfairModal open onClose={handleMaybeLater} isCalledByAnotherModal>
      <FfairPaper className={classes.root}>
        <IconButton
          size="small"
          className={classes.closeButton}
          onClick={handleMaybeLater}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h2" className={classes.title}>
          <T keyName="common.two_factor.activation.title" />
        </Typography>
        <Alert severity="info" fullWidth className={classes.alert}>
          <T keyName="common.two_factor.activation.description" />
        </Alert>
        <FormControlLabel
          className={classes.checkboxRow}
          control={
            <Checkbox
              checked={dontShowAgain}
              onChange={(e) => setDontShowAgain(e.target.checked)}
              color="primary"
            />
          }
          label={t("common.two_factor.activation.dont_show_again")}
        />
        <Box className={classes.footer}>
          <Button color="primary" onClick={handleMaybeLater}>
            <T keyName="common.two_factor.activation.maybe_later" />
          </Button>
          <Button variant="contained" color="primary" onClick={handleEnable}>
            <T keyName="common.two_factor.activation.enable" />
          </Button>
        </Box>
      </FfairPaper>
    </FfairModal>
  );
};

export default ActivationPromptModal;
